import * as actionTypes from "../../Action/actionTypes";

/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/11/19
 * Time: 10:21 AM
 */
const initialState = {
  system_changer:1
};

const reducer=(state=initialState,action)=>{
  switch(action.type){


    case actionTypes.SYSTEM_CHANGER:
      return {
        ...state,
        system_changer: action.value
      };

    default:
      return state;
  }
};

export default reducer;
